/* eslint-disable @typescript-eslint/no-explicit-any */
import { useAuthentication } from '@/hooks/useAuthentication';
import { useBookmarkStore } from '@/pages/bookmarks/store/useBookmarkStore';
import { addBookmark, existBookmark, findBookmark, removeBookmark } from '@/services/bookmark/bookmark.service';
import { useEffect, useState } from 'react';
import { Course, GENERATED, Resource } from '@edwin-group/cj-graphql';
import { trackGAEvent } from '@/lib/ga-custom-events/dispatcher';
import { Chapter } from '@/types/types';

export default function useBookmark({ relationId }: { relationId: string }) {
  const [exist, setExist] = useState<boolean>(false);
  const { authentication } = useAuthentication();
  const { removeFromBookmark, page, onInitPage } = useBookmarkStore();

  // TODO: Implement this
  const getTitle = (metadata: Chapter | Resource | Course) => {
    if (metadata?.__typename === 'Resource') {
      return metadata?.title ?? metadata?.attributes?.title ?? '';
    }

    if (metadata?.__typename === 'Course') {
      return metadata?.title ?? metadata?.attributes?.title ?? '';
    }

    if (metadata?.__typename === 'ComponentMissionChapters') {
      return metadata?.title ?? metadata?.attributes?.title ?? '';
    }

    return '';
  };

  const handleClick = async (
    metadata: any,
    typeId?: string,
    category?: GENERATED.Enum_Bookmark_Category,
    onRemoveFromBookmark?: () => void,
  ) => {
    try {
      if (exist) {
        const { data } = await findBookmark(relationId);
        if (!data?.bookmarks?.data[0]?.id) return console.error('Bookmark not found');
        await removeBookmark(data?.bookmarks?.data[0]?.documentId || '');
        await removeFromBookmark(category || GENERATED.Enum_Bookmark_Category.Resource);
        setExist(false);

        if (onRemoveFromBookmark) {
          onRemoveFromBookmark();
        }
      } else {
        trackGAEvent('bookmarked', {
          type: category ?? '',
          name: getTitle(metadata),
        });
        await addBookmark({
          category,
          metadata: JSON.stringify(metadata),
          relationId,
          resource_type: typeId,
          staff: `${authentication?.user?.documentId}`,
        });
        setExist(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    (async () => {
      await onInitPage();
    })();
  }, [onInitPage]);

  useEffect(() => {
    (async () => {
      if (!relationId) return;
      const { data } = await existBookmark(relationId);
      setExist((data?.bookmarks?.data?.length || 0) > 0);
    })();
  }, [relationId]);

  return { exist, page, handleClick };
}
